import grids from '../../data/grids'
import Grid from '../../models/Grid'



// initial state
const state = () => ({

})

// getters
const getters = {
    filtered() {
        return Grid.query().withAllRecursive().all()
    }
}

// actions
const actions = {
    load({ commit }) {
        commit('load', grids)
    },
}

// mutations
const mutations = {
    load(state, grids) {
        Grid.create({
            data: grids
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}